var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full justify-self-center",class:[
    _vm.contentPosition(_vm.contentPositionMobile, _vm.contentPositionDesktop),
    _vm.rowGap,
    _vm.rowGapDesktop,
    _vm.maxWidth,
    _vm.maxWidthDesktop,
    _vm.paddingHorizontal,
    _vm.paddingHorizontalDesktop,
  ]},_vm._l((_vm.content),function(title){return _c(title.component,_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(title),expression:"title"}],key:title._uid,tag:"component"},'component',title,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }